module.exports = __webpack_public_path__ + "img/47_18.5467358b.png";